export default "__VITE_ASSET__BfJ0kSCH__"